import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { converterType } from "@dcc/types/converterType";
import {
  roundToNDecimalPlaces,
  roundUpToNDecimalPlaces
} from "@dcc/common/rounding";

export const getDailyValueForWeeklyDrinker = (
  value: number,
  numberOfDrinkingDays: number
) =>
  numberOfDrinkingDays > 0
    ? roundToNDecimalPlaces(value / numberOfDrinkingDays, 2)
    : 0;

export const weeklyUnitAndCaloriesConverter: () => converterType = () => ({
  [DrinkFrequency.Never]: (value: number) => value,
  [DrinkFrequency.Weekly]: (value: number) =>
    roundUpToNDecimalPlaces(roundToNDecimalPlaces(value, 3), 2),

  [DrinkFrequency.Monthly]: (value: number) => value,
  [DrinkFrequency.TwiceMonthly]: (value: number) => value
});

export const dailyUnitAndCaloriesConverter: (
  numberOfDrinkingDays: number
) => converterType = (numberOfDrinkingDays: number) => ({
  [DrinkFrequency.Never]: (value: number) => value,
  [DrinkFrequency.Weekly]: (value: number) =>
    getDailyValueForWeeklyDrinker(value, numberOfDrinkingDays),
  [DrinkFrequency.Monthly]: (value: number) => value,
  [DrinkFrequency.TwiceMonthly]: (value: number) => value
});
